exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-box-icon.top[data-v-0d33ed55]{display:block}a.mini-link[data-v-0d33ed55]{color:#fff;text-transform:lowercase}a.mini-link[data-v-0d33ed55]:hover{text-decoration:none}div.bg-warning a.mini-link[data-v-0d33ed55]{color:#1f2d3d!important}", ""]);

// exports
